// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
.inactive-label {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
  padding: 10px 12px;
  background: #fff3e0;
  border-radius: 4px;
  border-left: 3px solid #e65100;
}

.inactive-name-label {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
  white-space: nowrap;
}

.inactive-name-value {
  color: #333;
}

.search-field {
  width: 100%;
  margin-bottom: 8px;
}

.results-list {
  max-height: 240px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 12px;
}

.result-item {
  display: flex;
  align-items: baseline;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.result-item:last-child {
  border-bottom: none;
}
.result-item:hover {
  background: #f5f5f5;
}
.result-item.selected {
  background: #e3f2fd;
  border-left: 3px solid #0066b2;
}

.result-code {
  font-family: "GothamBold", Arial, sans-serif;
  color: #0b2d71;
  min-width: 100px;
  white-space: nowrap;
}

.result-description {
  color: #555;
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.no-results {
  text-align: center;
  color: #888;
  font-style: italic;
  padding: 16px;
}

.selected-preview {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #e8f5e9;
  border-radius: 4px;
  margin-top: 8px;
  font-size: 13px;
  color: #2e7d32;
}

.selected-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #388e3c;
}

.inline-spinner {
  display: inline-block;
  vertical-align: middle;
  margin-right: 6px;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
